/******************************************************************************
 * Copyright 2014-2017 VMware, Inc.  All rights reserved.
 *****************************************************************************/

/**
 * appblast-log.js
 *
 *    Implement logging in a way that takes advantage of modern
 *    browser debugging features but gracefully degrades on older
 *    browsers.
 *
 */


var log = (function() {
   var nullFunc = function() {
      },
      ret = {},
      levels = ["trace", "debug", "info", "warn", "error"];


   ret.LEVEL_TRACE = 0;
   ret.LEVEL_DEBUG = 1;
   ret.LEVEL_INFO = 2;
   ret.LEVEL_WARN = 3;
   ret.LEVEL_ERROR = 4;


   /**
    * getMethod
    *
    *    Bind to the named console method, or provide a fallback
    *    implementation. If console or console.log are not defined, we
    *    return dummy implementation which does nothing.
    *
    *    If the named method exists on the console, then we return a
    *    binding of that method. If it does not exist, we return
    *    console.log with the log level curried in.
    *
    *    If Function.prototype.bind does not exist, we raise an error.
    */

   function getMethod(name) {
      if (nullFunc.bind === undefined) {
         throw new Error("log requires Function.prototype.bind");
      }

      if ((console === undefined) || (console.log === undefined)) {
         return nullFunc;
      } else if (console[name] !== undefined) {
         return console[name].bind(console);
      } else {
         return console.log.bind(console, name);
      }
   }

   /**
    * setLevel
    *
    *    sets the current log level.
    */

   ret.setLevel = function(level) {
      var i;

      if ((typeof level !== "number") ||
         (level < 0) ||
         level > (levels.length - 1)) {
         throw new Error("Invalid log level: " + level);
      }

      for (i = 0; i < level; i++) {
         ret[levels[i]] = nullFunc;
      }

      for (i = level; i < levels.length; i++) {
         // log level trace is implemented as debug.
         // see: log.stackTrace() below.
         if (levels[i] === "trace") {
            ret.trace = getMethod("debug");
         } else {
            ret[levels[i]] = getMethod(levels[i]);
         }
      }

      ret.logLevel = level;
   };

   /**
    * log
    *
    *    binding of console.log or a dummy implementation.
    */

   ret.log = getMethod("log");

   /**
    * log
    *
    *    In modern browsers, console.trace() is not trace level
    *    logging, but actually a means to produce a stacktrace on the
    *    console. Our code defines LEVEL_TRACE as the loweset level of
    *    logging, so we expose console.trace here as log.stackTrace().
    */

   ret.stackTrace = getMethod("trace");


   /**
    * setLevel
    *
    *    Change the current log level. Log level must be an integer
    *    from LEVEL_TRACE to LEVEL_ERROR. Changing the log level to
    *    suppress a logging prevents the browser's console methods
    *    from ever being called, so they will never apear in the
    *    console regardless of the console filter settings used.
    */

   ret.setLevel(ret.LEVEL_DEBUG);
   ret.levels = levels;
   return ret;
}());

/**
 *  NOTE: this is the workaround for RTAV workers.
 *  We don't use webpack for these workers as there are many complex function
 *  in them. As a result, we have to use this ugly way to expose 'log' to other
 *  webpack module, but not for worker context.
 */
if (typeof module !== "undefined" && module.exports) {
   module.exports = log;
}
